import React, { useEffect, useState } from "react";
import {
    movePropertyToAuction,
    setAuctionFormStep,
} from "../../../../redux/action/sellerAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchEmsignerStatus } from "../../../../redux/action/buyerAction";
import useTranslationHook from "../../../hooks/useTranslationHook";
import SocketService from "../../../../Service/SocketService";
import EmsignerIframe from "../../../common/EmsignerIframe";
import { relayEmsignerCompletion } from "../../../../utils";

const StepTwoForm = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslationHook();
    const dispatch = useDispatch();

    const [isProcessingCallback] = useState(() => {
        const raw = window.location.search;
        const normalized = raw.slice(0, 1) + raw.slice(1).replace(/\?/g, "&");
        const result = !!new URLSearchParams(normalized).get("workflowid");
        console.info("[StepTwoForm] mount — isProcessingCallback:", result, "| search:", raw);
        return result;
    });

    const { id } = useParams();

    const stepOneData = useSelector(
        (state) => state.seller.property.auction.stepOneData
    );
    const propertyData = useSelector(
        (state) => state.seller.property.propertyData
    );
    const { listed_by: { first_name, last_name } = {} } = propertyData || {};

    const signatureValue =
        `${first_name || ""} ${last_name !== "NA" ? last_name || "" : ""}`.trim();

    useEffect(() => {
        const rawSearch = window.location.search;
        const normalized =
            rawSearch.slice(0, 1) + rawSearch.slice(1).replace(/\?/g, "&");
        const urlParams = new URLSearchParams(normalized);
        const workflowid = urlParams.get("workflowid");
        console.info("[StepTwoForm] location.search changed — workflowid:", workflowid);
        if (!workflowid) return;

        urlParams.delete("workflowid");
        urlParams.delete("referenceno");
        urlParams.delete("esState");
        const cleanSearch = urlParams.toString()
            ? `?${urlParams.toString()}`
            : "";

        navigate(
            { pathname: location.pathname, search: cleanSearch },
            { replace: true }
        );
        dispatch(fetchEmsignerStatus(id, "auction_mendate")).then((verifyRes) => {
            console.info("[StepTwoForm] fetchEmsignerStatus response:", verifyRes);
            const status = verifyRes?.data?.user_sing_status;
            if (status === "completed" || status === "pending") {
                dispatch(movePropertyToAuction(id)).then((res) => {
                    console.info("[StepTwoForm] movePropertyToAuction response:", res);
                    if (!res || res.error !== 0) return;
                    SocketService.send("isCallCheckBid", { property_id: id });
                    if (window !== window.top || window.opener) {
                        console.info("[StepTwoForm] inside iframe/new tab — relaying AUCTION_SAVED");
                        relayEmsignerCompletion({
                            type: "AUCTION_SAVED",
                            path: "/seller/property/success/",
                        });
                    } else {
                        navigate("/seller/property/success/");
                    }
                });
            } else {
                toast.info(verifyRes?.data?.msg);
            }
        });
        //eslint-disable-next-line
    }, [location.search]);

    return (
        <section className="property-wrap auction-wrap">
            <div className="container py-5">
                <div className="row justify-content-md-center">
                    <div className="col-lg-8">
                        <div>
                            <div className="counter">{t("2/2")}</div>
                            <h5 className="display-5 mb-3">
                                {t("Reservation Agreement")}
                            </h5>
                            <ul className="property-progress">
                                <li className="full" />
                                <li className="active" />
                            </ul>
                            <div className="row pt-5">
                                <div className="col-md-12">
                                    <div className="mb-4">
                                        <label
                                            htmlFor="textLabel"
                                            className="form-label"
                                        >
                                            {t(
                                                "Please review and sign the reservation agreement to reserve your property for auction."
                                            )}
                                        </label>
                                        {!isProcessingCallback && (
                                            <EmsignerIframe
                                                propertyId={id}
                                                agreementType="auction_mendate"
                                                signature={signatureValue}
                                                stateData={stepOneData}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="row pt-5">
                                <div className="col-md-6">
                                    <button
                                        type="button"
                                        className="btn btn-sky btn-lg"
                                        onClick={() =>
                                            dispatch(setAuctionFormStep(1))
                                        }
                                    >
                                        <i className="fa-solid fa-angle-left mr4" />
                                        {t("Back")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default StepTwoForm;
